// ── Run stop status classification ──────────────────────────────────────── //

export type RunStopPhase = 'pending' | 'active' | 'completed' | 'skipped';

export function classifyRunStopStatus(status: string): RunStopPhase {
  if (status === 'completed') return 'completed';
  if (status === 'skipped') return 'skipped';
  if (
    status === 'in_transit_to' ||
    status === 'arrived' ||
    status === 'in_service' ||
    status === 'service_in_progress'
  )
    return 'active';
  return 'pending';
}

// ── Run map data shapes ─────────────────────────────────────────────────── //

export interface RunMapStopLocation {
  id: number;
  name?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  geofence_radius?: number | null;
  geofence_vertices?: Array<{ lat: number; lng: number }> | null;
  geofence_center_lat?: number | null;
  geofence_center_lng?: number | null;
}

export interface RunMapStop {
  id: number;
  stopOrder: number;
  status: string;
  phase: RunStopPhase;
  address?: string | null;
  lat: number;
  lng: number;
  location?: RunMapStopLocation | null;
  customerName?: string | null;
  customerPhone?: string | null;
  serviceDescription?: string | null;
  estimatedServiceMinutes?: number | null;
}

// ── Run overlay set ─────────────────────────────────────────────────────── //

export interface RunOverlaySet {
  stopMarkers: google.maps.Marker[];
  geofences: (google.maps.Circle | google.maps.Polygon)[];
  routePolylines: google.maps.Polyline[];
  routeAnimated: google.maps.Polyline | null;
}

// ── Clicked run stop (for popup) ────────────────────────────────────────── //

export interface ClickedRunStop {
  stop: RunMapStop;
  screenX: number;
  screenY: number;
}

// ── Stop color palette ──────────────────────────────────────────────────── //

export const RUN_STOP_COLORS: Record<RunStopPhase, string> = {
  pending: '#cbd5e1',    // slate-300
  active: '#3b82f6',     // blue-500
  completed: '#22c55e',  // green-500
  skipped: '#ef4444',    // red-500
};

export const RUN_ROUTE_COLOR = '#94a3b8'; // slate-400
export const RUN_ROUTE_ACTIVE_COLOR = '#3b82f6'; // blue-500
